export class SIBLabelConstants {
  // -----------------------Customer Module--------------------------------
  public static DND_FLAG_LABEL = "DND";

  // Monthly rate Labels
  public static NET_RATE_PM = "Net Rate P.M."; // For Chitra B
  public static MONTHLY_RATE = "Monthly Rate"; // In General
}
